import {
  ChangeDetectionStrategy,
  Component,
  forwardRef,
  OnDestroy,
} from "@angular/core";
import {
  ControlValueAccessor,
  FormBuilder,
  FormControl,
  FormGroup,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
} from "@angular/forms";
import { Subscription } from "rxjs";

@Component({
  selector: "contact-details",
  templateUrl: "contact-details.html",
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ContactDetails),
      multi: true,
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ContactDetails),
      multi: true,
    },
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ContactDetails implements ControlValueAccessor, OnDestroy {
  innerFormGroup: FormGroup;
  subscriptions: Subscription[] = [];

  get value(): any {
    return this.innerFormGroup.value;
  }

  set value(value: any) {
    this.innerFormGroup.patchValue(value);
    this.onChange(value);
    this.onTouched();
  }

  constructor(protected formBuilder: FormBuilder) {}

  ngOnDestroy() {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onChange: any = (value) => {};
  onTouched: any = () => {};

  registerOnChange(fn) {
    this.onChange = fn;
  }

  writeValue(value) {
    if (value) {
      this.value = value;
    }

    if (value === null) {
      this.innerFormGroup.reset();
    }
  }

  registerOnTouched(fn) {
    this.onTouched = fn;
  }

  validate(_: FormControl) {}

  reset() {
    this.innerFormGroup.reset();
  }
}



// WEBPACK FOOTER //
// ./src/pages/company-resources/contact-details/contact-details.ts